export const shellPath = '/pwa/shell'
